import { render } from "./ImportPatient.vue?vue&type=template&id=477849e5&scoped=true"
import script from "./ImportPatient.vue?vue&type=script&lang=js"
export * from "./ImportPatient.vue?vue&type=script&lang=js"

import "./ImportPatient.vue?vue&type=style&index=0&id=477849e5&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477849e5"]])

export default __exports__